var generateStyle = function generateStyle(componentTheme) {
  return {
    wrapper: {
      position: 'relative',
      width: '100%',
      boxSizing: 'border-box',
      padding: componentTheme.wrapperPadding,
      '&::after': {
        clear: 'both',
        content: '""',
        display: 'table'
      },
      '.user_content p': {
        margin: "".concat(componentTheme.userContentMargin, " 0"),
        '&:first-of-type': {
          margin: "0 0 ".concat(componentTheme.userContentMargin)
        },
        '&:last-of-type': {
          margin: "".concat(componentTheme.userContentMargin, " 0 0")
        },
        '&:only-child': {
          margin: 0
        }
      }
    },
    text: {
      fontSize: componentTheme.textFontSize
    }
  };
};
export default generateStyle;